var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.915039,
    y: 0.5,
    width: 10,
    height: 10,
    rx: 2.5,
    fill: "#E2EBFF",
    stroke: "#CDD6E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.72754 7.80001H5.04004V5.82499H4.72754C4.55495 5.82499 4.41504 5.70258 4.41504 5.55156V4.89844C4.41504 4.74742 4.55495 4.625 4.72754 4.625H6.47754C6.65013 4.625 6.79004 4.74742 6.79004 4.89844V7.80001H7.10254C7.27513 7.80001 7.41504 7.92242 7.41504 8.07344V8.72656C7.41504 8.87758 7.27513 9 7.10254 9H4.72754C4.55495 9 4.41504 8.87758 4.41504 8.72656V8.07344C4.41504 7.92242 4.55495 7.80001 4.72754 7.80001ZM5.91504 2C5.29371 2 4.79004 2.44071 4.79004 2.98438C4.79004 3.52804 5.29371 3.96875 5.91504 3.96875C6.53637 3.96875 7.04004 3.52804 7.04004 2.98438C7.04004 2.44071 6.53635 2 5.91504 2Z",
    fill: "#9AACCF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.2b7a9647.svg";
export { ForwardRef as ReactComponent };